import { Box } from '@chakra-ui/react';
import PastReviewModal from './PastReviewModal';
import { useState } from 'react';
import { IGetRevisionHistory } from '@publishing-engine/submission-service/src/endpoints/api.response-types';
import { RoundReview } from './RoundReview';
import { Tooltip } from '@chakra-ui/tooltip';
type IProps = {
  round: IGetRevisionHistory;
  submissionContextId?: string;
};
export const PastReview: React.FC<IProps> = ({ round, submissionContextId }) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const onClose = () => {
    setIsOpenModal(false);
  };
  return (
    <>
      <Box>
        <Box margin={1} padding={1}>
          {round?.reviewerRevisionFeedback?.map(item => {
            return (
              <>
                <Tooltip
                  hasArrow
                  placement="top"
                  label={'View your review'}
                  borderRadius={4}
                  data-cy="contributions-info-tooltip"
                >
                  <Box
                    cursor="pointer"
                    _hover={{ bg: 'gray.100' }}
                    borderBottom={'1px'}
                    borderColor="neutralPrimaryBorder"
                    padding={2}
                    paddingBottom={4}
                    paddingTop={3}
                    onClick={() => setIsOpenModal(true)}
                  >
                    <RoundReview
                      comment={item?.reviewAssessment?.feedbackForAuthors.original}
                      ReviewerName={`${item?.reviewer?.firstName} ${item?.reviewer?.lastName}`}
                      status={item?.reviewAssessment?.recommendation}
                    />
                  </Box>
                </Tooltip>
              </>
            );
          })}
          {round?.anonymousComments?.map((item, index) => {
            return (
              <>
                <Box
                  borderBottom={'1px'}
                  borderColor="neutralPrimaryBorder"
                  padding={2}
                  paddingBottom={4}
                  paddingTop={3}
                >
                  <RoundReview
                    comment={item.feedbackForAuthors}
                    Reviewernumber={index + 1}
                    status={item.recommendation}
                  />
                </Box>
              </>
            );
          })}
        </Box>
      </Box>
      {isOpenModal && <PastReviewModal round={round} onClose={onClose} submissionContextId={submissionContextId} />}
    </>
  );
};
